<template lang="pug">
article.podcast-card(
  :class="{ 'podcast-card--active': active }")
  template(v-if="loading")
    .podcast-card__thumbnail.clp
    .podcast-card__info
      .podcast-card__title.clp.w-8 &nbsp;
      .podcast-card__summary.clp.w-10 &nbsp;
      //- .podcast-card__metas
        .podcast-card__mins.clp.w-2 &nbsp;

  template(v-else)
    nuxt-link.podcast-card__thumbnail(
      v-image="thumbnail"
      :to="to"
      :title="entry.title")
      .podcast-card__playing(v-if="active")
        svg(width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
          rect(x="4" y="4" width="4" height="16" fill="white")
          rect(x="10" y="4" width="4" height="16" fill="white")
          rect(x="16" y="4" width="4" height="16" fill="white")

    nuxt-link.podcast-card__info(
      :to="to"
      :title="entry.title")
      .podcast-card__title.pf-clamp-3(
        v-text="entry.title")
      .podcast-card__summary.pf-clamp-3(
        :title="entry.summary"
        v-text="entry.summary")
      //- .podcast-card__metas
        .podcast-card__mins {{ entry.mins }} {{ entry.mins > 1 ? 'mins' : 'min' }}

</template>

<script>
export default {
  props: {
    entry: {
      type: Object,
      default: () => ({})
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    thumbnail () {
      return this.entry.thumbnail_product_url
    },

    to () {
      return {
        name: 'podcasts',
        query: {
          episode: this.entry.slug
        }
      }
    },

    active () {
      return this.$route.query.episode === this.entry?.slug
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes equalize {
  0% { transform: scaleY(0.3); }
  50% { transform: scaleY(1); }
  100% { transform: scaleY(0.3); }
}

.podcast-card {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  > * {
    min-width: 0;
  }
  &--active {
    .podcast-card__info {
      font-weight: $--font-weight-semibold;
    }
    .podcast-card__title,
    .podcast-card__summary {
      color: $--color-primary;
    }
  }
  &__playing {
    position: absolute;
    top: 4px;
    right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    svg {
      rect {
        animation: equalize 1s infinite;
        transform-origin: center;
        &:first-child { animation-delay: 0.1s; }
        &:nth-child(2) { animation-delay: 0.2s; }
        &:nth-child(3) { animation-delay: 0.3s; }
      }
    }
  }
  &__thumbnail {
    flex: 0 140px;
    position: relative;
    display: block;
    aspect-ratio: 16 / 9;
    background: $--color-placeholder;
    border-radius: $--radius-lg;
    background-size: cover;
    background-position: center;
    &:hover {
      strong {
        transform: scale(1.1);
        background: rgba(black, .3);
      }
    }
    strong {
      position: absolute;
      top: 24px;
      right: 24px;
      background: rgba(black, .2);
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100%;
      font-size: 2rem;
      color: white;
      padding-left: .15em;
      transition: all .2s ease-in-out;
      backdrop-filter: blur(8px);
      pointer-events: none;
    }
  }
  &__info {
    flex: 1;
  }
  &__metas {
    display: flex;
    gap: 1rem;
    align-items: center;
    > * {
      min-width: 0;
    }
  }
  &__mins {
    color: $--color-text-secondary;
  }
  &__title {
    color: $--color-primary-dark;
    font-size: 14px;
    line-height: 150%;
    display: block;
  }
  &__summary {
    color: $--color-text-secondary;
    font-size: 16px;
    line-height: 150%;
    margin: 4px 0;
  }
}
</style>
